/**
 * Constants for Branch Scheme actions.
 * URL in these constants are having dynamic variables
 * wrapped in {}, replace them with original dynamic variables
 * in order to send API requests.
 */

export const BRANCH_SCHEME_LIST_URL =
  "/scheme-planning/ims/budgetplans?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const BRANCH_SCHEME_DETAIL_URL = "/scheme-planning/ims/budgetplan/{branchSchemeId}";
export const BRANCH_SCHEME_HEADER_SAVE_URL = "/scheme-planning/ims/budgetplan/save";
export const BRANCH_SCHEME_LINES_LIST_URL = "/scheme-planning/ims/budgetline/{id}?pageNo={currentPage}&pageSize={pageSize}&sortBy={value}{sortOrder}";
export const BRANCH_LINES_UPLOAD_CSV_URL = "/scheme-planning/ims/upload/budget/{id}";
export const BRANCH_LINES_EXCEL_URL =
  "/scheme-planning/ims/download/budgettemplate/{id}";
export const BRANCH_LINES_UPDATE_URL =
  "/scheme-planning/ims/budgetline/edit";  
export const DELETE_BRANCH_SCHEME_URL =
  "/scheme-planning/ims/budgetplan/delete/{branchSchemeId}";
  export const DELETE_BRANCH_SCHEME_LINES_URL =
  "/scheme-planning/ims/budgetline/delete?id={id}";